
import React, { useEffect, useState } from 'react'
import { useHistory } from 'react-router-dom'
import { API } from 'aws-amplify'
import StoryTitle from '../components/StoryTitle'
import StoryTable from '../components/StoryTable'
import color from '../shared/color'
import { ChoroplethUS, DonutChart, ScatterPlot, ThresholdBarChart } from '../d3'
import { Typography, Grid, CircularProgress, Paper } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import '../story.css'

function TfsCurrentState() {

    const [title] = useState("Microsoft Team Foundation Server Backlog")
    const [summary] =  useState("Output of Microsoft Team Foundation Server to understand the Med ES and PLX backlog.")
    const [categories] = useState(["performance","microsoft"])
    const [isLoading, setIsLoading] = useState(true)
    const [data, setData] = useState(null)
    const [filterLayout] = useState([
        {column:"Column", field:"column_name"},
        {column:"Filter Value", field: "value_name"},
        {column:"Product Type",field:"producttype"}
    ])
    const [revLayout] = useState([
        {column:"Grouping Value", field:"grouping"},
        {column:"Result", field: "value_name"}
    ])
    const [tfsLayout] = useState([
        {column:"Established TFS Value", field:"tfsValue"}
    ])

    const [bubbleColor, setBubColor] = useState(null)
    const useStyles = makeStyles({
        table: {
            minWidth: 650,
        },
    })

    let history = useHistory()

    useEffect(() => {
        setBubColor(new Map([
            ["Scheduled_with_permission", "#4e79a7"],
            ["Customer_Managed", "#f28e2c"],
            ["Scheduled_wo_permission", "#59a14f"]
          ]))
        async function fetch() {
            await API.get('qs-web-api', '/data/tfscurrentstate/tfscurrentstate.json', {})
                .then((storyData) => {
                    setData(storyData)
                })
                .catch(function (error) {
                    console.log(error)
                })
            setIsLoading(false)
        }
        fetch()
    }, [])

    if (isLoading) {
        return (<div className="circular-progress"><CircularProgress disableShrink /></div>)
    } else {
        return (
            <div id="story">
                <StoryTitle title={title} date={data.date} categories={categories}></StoryTitle>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="subText">
                        <Typography >
                             Microsoft Team Foundation Server (TFS) is software that helps teams manage code and develop projects. BD MMS has utilized TFS for decades storing {data.recordCountOverall} million records, {data.recordCountOverallTitles} thousand unique issues.
 <p>
 </p>
 <p>
 Using the area paths of D_And_A_Ops, DEVOPS, DaVinci ,GCSM, Med , MedStation ,PHACTS and Pyxis Anesthesia, a count of {data.recordCountSubset} million records, {data.recordCountSubsetTitles} thousand unique issues were scanned to find issues relating to Med ES Products and PLX. Certain area paths were not choose as they were not an MMS R&D team like, GCS or a legacy product like CIISafe system area path.
 </p>
 <p>
 The main elements to filter the TFS data are system area path, labeling to call out Med ES Product or PLX and system work item type. Each filter type is documented in the report near the end for transparency.
 </p>
 <p>
 Overall each record is associated with an ID which can be called an Issue. The issue can change over time while the ID should remain consistent.
 </p>
 <p>
 Quality documentation standard Sec. 820.180 General requirements included at the end of the documentation, which shows that the issues need to be retained for the product life cycle until end of life.
 </p>
 <p>
Currently the TFS data source requires a manual cloning from BD TGS (IT). The data source earliest value is {data.earlyDateRecord} and the latest value is {data.latestDateRecord} which makes the total age of the data source {data.daysOldDataRecord} years. Many of the records are not available in the current Microsoft TFS webpage/dashboard does not show as much data as the database.
 </p>
 <p>
 The goal of the analysis is to be able to show trends and usage of TFS for Med ES Products and PLX. Considering the lack of standardization over the decade-long run time of TFS, the logic for assigning and parsing the products will be included in the bottom of the analysis. The analysis is around bug/issue tracking the main filters will be for open issues, that are in the work item type of Bug/Issue/Production Issue.
 </p>
                        </Typography>
                        </div>
                    </Grid>
                </Paper>

                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h5" fontWeight="bold">
                                Previous Year Review Context
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Trend of Overall Backlog Changes - Last year
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterBackLogYear} axis={{x: "Data Extracted Date", y: "# of Days"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeBackLogYear} tooltip = {"Number of Issues: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Calculating the total backlog and change over the last year for production issues, issues and bugs. The historical graph is below.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>


              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Trend of Current Closed and Open Issues - Last year
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterWholeMonthlyIssues} axis={{x: "Data Extracted Date", y: "# of Issues"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeWholeMonthlyIssues} tooltip = {"# of Issues: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Looking at the overall rate of closed and open items over the last year for production issues, issues and bugs.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>


                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Open Work Item Type Breakdown - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutsystemWorkItemTypeSimpleYear} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Overall Work Item Types for Med ES and PLX for the last year since.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Current State Breakdown - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutcurrentStatus_count} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            The overall TFS current state for open issues in TFS over the last year from the TFS datasource pull.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Insight Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTIYear} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                               {data.donutAgeStatusMeanMTIYear} days is the amount of time the investigation is open till changed to production issue complete.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Task Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTTYear} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                {data.donutAgeStatusMeanMTTYear} days is the amount of time the task is open till to closed.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Resolve Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTRYear} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                {data.donutAgeStatusMeanMTRYear} days is the amount of time the issue is open till to closed.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>


                          <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Med ES Trend of Current Closed and Open Issues - Last year
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterWholeMonthlyIssuesMED} axis={{x: "Data Extracted Date", y: "# of Issues"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeWholeMonthlyIssuesMED} tooltip = {"Number of Med ES Stations: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
Looking at bugs/issues/production issues that are showing med es based on the last year of data from the TFS datasource by month.
</Typography>
                        </div>
                    </Grid>
            </Paper>






            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Med ES Open Work Item Type Breakdown - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutsystemWorkItemTypeSimpleYearMED} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Overall Work Item Types for Med ES  in the last year since the pull date of the TFS datasource.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Med ES Current State Breakdown - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutcurrentStatus_countMED} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            The Med ES TFS current state for open issues in TFS - Last year
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Med ES Insight Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTIYearMED} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                               {data.donutAgeStatusMeanMTIYearMED} days is the amount of time the investigation is open till changed to production issue complete.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Med ES Task Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTTYearMED} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                {data.donutAgeStatusMeanMTTYearMED} days is the amount of time the task is open till to closed.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Med ES Resolve Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTRYearMED} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                {data.donutAgeStatusMeanMTRYearMED} days is the amount of time the issue is open till to closed.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>


                          <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                PLX Trend of Current Closed and Open Issues - Last year
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterWholeMonthlyIssuesPLX} axis={{x: "Data Extracted Date", y: "# of Issues"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeWholeMonthlyIssuesPLX} tooltip = {"Number of Med ES Stations: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                Looking at bugs/issues/production issues that are showing  plx based on the last year.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>








            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                PLX ES Open Work Item Type Breakdown - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutsystemWorkItemTypeSimpleYearPLX} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Overall Work Item Types for PLX in the last year since the pull date of the TFS datasource.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                PLX Current State Breakdown - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutcurrentStatus_countPLX} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            The PLX TFS current state for open issues in TFS over the last year from the TFS datasource pull.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

               <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                PLX Insight Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTIYearPLX} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                               {data.donutAgeStatusMeanMTIYearPLX} days is the amount of time the investigation is open till changed to production issue complete.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                PLX Task Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTTYearPLX} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                {data.donutAgeStatusMeanMTTYearPLX} days is the amount of time the task is open till to closed.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                PLX Resolve Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTRYearPLX} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                {data.donutAgeStatusMeanMTRYearPLX} days is the amount of time the issue is open till to closed.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>







                <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h5" fontWeight="bold">
                                Holistic Data Source Context
                            </Typography>
                        </div>
                    </Grid>
              </Paper>





              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Trend of Overall Backlog
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterBackLog} axis={{x: "Data Extracted Date", y: "# of Issues"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeBackLog} tooltip = {"Number of Med ES Stations: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Looking at bugs/issues/production issues historical count and rate of removal.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>




              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Insight Timing - Last year
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTI} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                               {data.donutAgeStatusMeanMTI} days is the amount of time the investigation is open till changed to production issue complete.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                 Task Timing
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTT} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                {data.donutAgeStatusMeanMTT} days is the amount of time the task is open till to closed.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                 Resolve Timing
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutAgeStatusMTR} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                {data.donutAgeStatusMeanMTR} days is the amount of time the issue is open till to closed.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>







             <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                PLX and Med ES TFS Production Issues based on Quarter based off Created Date
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <ThresholdBarChart data={data.overallRecordsByQuarterCreated} colors={["#157DD8","#B00020"]} axis={{x: "Number of Records",y: "Date"}} width={900} height={450} threshold={new Date(data.latestDateRecordMinusYear)} tooltip={"Quarter Summary of Records:<br>"}></ThresholdBarChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                Red are the records that are over a year past due from the last time the TFS DB clone was made.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>






            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                PLX and Med ES TFS Production Issues based on Quarter of Latest Change
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <ThresholdBarChart data={data.overallRecordsByQuarter} colors={["#157DD8","#B00020"]} axis={{x: "Number of Records",y: "Date"}} width={900} height={450} threshold={new Date(data.latestDateRecordMinusYear)} tooltip={"Quarter Summary of Records:<br>"}></ThresholdBarChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                Red are the records that are over a year past due from the last time the TFS DB clone was made. Currently, the data source is being pulled manually so there needs to be a call out that certain records may still be active but the majority are inactive. Jan 2021 is due to a large effort to clear low hanging fruit from TFS.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>



            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Cumulative PLX and Med ES TFS Production Issues based on Quarter of Latest Change
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <ThresholdBarChart data={data.overallRecordsByQuarterRunningSumCum} colors={["#157DD8","#B00020"]} axis={{x: "Number of Records",y: "Date"}} width={900} height={450} threshold={new Date(data.latestDateRecordMinusYear)} tooltip={"Quarter Cumulative Summary of Records Percentage:<br>"}></ThresholdBarChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                Looking at a cumulative summary of issues, the Pareto rule shows that 80% are in the historical. Red are the records that are over a year past due from the last time the TFS DB clone was made.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>

            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Trend of Current Closed and Open Issues Per Quarter from Created Date
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterESCountsCurrentCreated} axis={{x: "Data Extracted Date", y: "# of Issues"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeCurrentCreated} tooltip = {"Number of Med ES Stations: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Overall the trend of creating Issues in TFS has remained fairly linear with overall closed items around the same as overall still in open. A trend of just the cumulative count of the backlog is below.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>

                                    <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                90th and 10th percentile of issue ages (days) in the last year
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterPercentile} axis={{x: "Data Extracted Date", y: "# of Days Old"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangePercentile} tooltip = {"Number of Med ES Stations: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            The amount of time a case has been open based on the delta of the created and closed, if the case is not closed it is based on today.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>

                        <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                90th and 10th percentile of issue ages (days)
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterPercentileQuarter} axis={{x: "Data Extracted Date", y: "# of Days Old"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangePercentileQuarter} tooltip = {"Number of Med ES Stations: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            The amount of time a case has been open based on the delta of the created and closed, if the case is not closed it is based on today.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>



            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Trend of Current Closed and Open Issues Per Quarter of Latest Change
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterESCountsCurrent} axis={{x: "Data Extracted Date", y: "# of Issues"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeCurrent} tooltip = {"Number of Med ES Stations: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            While the records are not based off the created date, even comparing the latest edited record has the Open items far outpacing the Closed items aside from Jan 2021 where a large effort went underway to remove old issues.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>

            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Trend of Cumulative Closed and Open Issues Per Quarter
                            </Typography>
                        </div>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center">
                        <ScatterPlot data={data.scatterESCountsCum} axis={{x: "Data Extracted Date", y: "# of Issues"}}
                                     width={900} height = {450} xType={"date"} yRange = {data.esyrangeCum} tooltip = {"Number of Med ES Stations: "}
                                     colors = {["#d87015","#ee9090","#157DD8","#90ee90"]}></ScatterPlot>
                    </Grid>
                   <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Backlog growth based on the holistic data source. Quarter is based on the created date. Filter till after 2014.
                            </Typography>
                        </div>
                    </Grid>
            </Paper>

                         <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Med ES and PLX Issues Record Distribution
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutCountRecords} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Many of the items are linked to each other and will ping back and forth making the count of records for the issue less helpful at determining usefulness.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>


             <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Production Issue Latest Product Status
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutProductStatus} colors={color.defaultScheme} tooltip={"Number of Records: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                Overall Production Issue Status simplified to reduce complexity of labels. The process for the status used a phased approach between active-new to closed-finished but lost standardization. Aggregation was required due to {data.donutProductStatusNumberofUnique} unique labels. The logic for wrangling the data is included at the end of the report.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Product Type Breakdown
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutRootCauseType} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Root Cause Type for closed items is mainly unpopulated, just like problem category and product type.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Product Type Breakdown
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutRootCauseTypeFilledIn} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                            Root Cause Type for closed items that were populated.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>

              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Production Issue Fixed Type
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutFixType} colors={color.defaultScheme} tooltip={"Number of Records: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                Production Issue Fixed Type breakdown over the sample of PLX and Med ES product types that were populated.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>





              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h5" fontWeight="bold">
                                Data Wrangling Logic
                            </Typography>
                        </div>
                    </Grid>
              </Paper>


              <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Product Type Breakdown
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutProductTypeUnknown} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                For the rest of the report the Not Applicable are ignored. While the Not Applicable amount is high, there are many other projects in the system area path that are not Med ES or PLX.   The wrangling logic for determining the production type is at the bottom of the page.  Essentially, there are many items that are not filled out correctly due to changing in leadership, direction and data quality. Ideally each product type would be filled out with a specific product, but most are null.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>




             <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="description">
                            <Typography variant="h6" fontWeight="bold">
                                Work Item Type Breakdown
                            </Typography>
                        </div>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <DonutChart id={1} data={data.donutsystemWorkItemTypeSimple} colors={color.defaultScheme} tooltip={"Number of Issues: "}
                            width={800} height={400} radius={200}></DonutChart>
                    </Grid>
                    <Grid container justify="center" spacing={2} alignItems="stretch">
                        <div className="subText">
                            <Typography>
                                For the rest of the report the Bug/Issue/Production are the filtered for values. Other work items are not reviewed as they are not detrimental to the product.
                            </Typography>
                        </div>
                    </Grid>
              </Paper>






                          <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="description">
                            <Typography variant="h6">
                                Filter criterion for determining if a product is Med ES Product Line or PLX.
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.filterLayoutTypes} layout={filterLayout}></StoryTable>
            </Paper>

            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="description">
                            <Typography variant="h6">
                                Filter criterion for determining if a Issue Status is an Enhancement/Open/Awaiting Release/Closed is Med ES Product Line or PLX.
                            </Typography>
                        </div>
                    </Grid>
                    <StoryTable data={data.revSimplicationLayoutTypes} layout={revLayout}></StoryTable>
            </Paper>

            <Paper className="storySection">
                    <Grid container justify="center" spacing={2} alignItems="stretch" >
                        <div className="description">
                            <Typography variant="h6">
                            <p>
                            Sec. 820.180 General requirements.
                            </p>
                            <p>
All records required by this part shall be maintained at the manufacturing establishment or other location that is reasonably accessible to responsible officials of the manufacturer and to employees of FDA designated to perform inspections. Such records, including those not stored at the inspected establishment, shall be made readily available for review and copying by FDA employee(s). Such records shall be legible and shall be stored to minimize deterioration and to prevent loss. Those records stored in automated data processing systems shall be backed up.
                            </p>
                            <p>
(a) Confidentiality. Records deemed confidential by the manufacturer may be marked to aid FDA in determining whether information may be disclosed under the public information regulation in part 20 of this chapter.
    </p>
                            <p>
(b) Record retention period. All records required by this part shall be retained for a period of time equivalent to the design and expected life of the device, but in no case less than 2 years from the date of release for commercial distribution by the manufacturer.
</p>
                            <p>
(c) Exceptions. This section does not apply to the reports required by § 820.20(c) Management review, § 820.22 Quality audits, and supplier audit reports used to meet the requirements of § 820.50(a) Evaluation of suppliers, contractors, and consultants, but does apply to procedures established under these provisions. Upon request of a designated employee of FDA, an employee in management with executive responsibility shall certify in writing that the management reviews and quality audits required under this part, and supplier audits where applicable, have been performed and documented, the dates on which they were performed, and that any required corrective action has been undertaken.
                            </p>
                            </Typography>
                        </div>
                    </Grid>
            </Paper>




            </div >
        )
    }
}

export default TfsCurrentState
